import { render, staticRenderFns } from "./Uninstall.vue?vue&type=template&id=674cc10e&scoped=true&"
import script from "./Uninstall.vue?vue&type=script&lang=js&"
export * from "./Uninstall.vue?vue&type=script&lang=js&"
import style0 from "./Uninstall.vue?vue&type=style&index=0&id=674cc10e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674cc10e",
  null
  
)

export default component.exports